module.exports = __webpack_public_path__ + "static/media/Rusty.838f62f9.png";